"use strict";Object.defineProperty(exports, "__esModule", {value: true}); const isEmailTooLong = (v) => v.length > 50; exports.isEmailTooLong = isEmailTooLong

 const isEmailValid = (value) => {
  if (!value || exports.isEmailTooLong.call(void 0, value)) return false
  /* a trusty regex from: http://emailregex.com/ */
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
}; exports.isEmailValid = isEmailValid
